import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SportsMartialArtsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sports_martial_arts"}/>
}
